import { useEffect, useRef } from 'react';
import { useNotifications } from './useNotifications';

const DEBOUNCE_MS = 1500;

/** Syncs the open conversation UUID to push_subscriptions.active_conversation_id */
export function usePushActiveConversation(conversationDbId: string | null) {
  const { updatePushPresence } = useNotifications();
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      void updatePushPresence(conversationDbId);
    }, DEBOUNCE_MS);

    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, [conversationDbId, updatePushPresence]);

  useEffect(() => {
    return () => {
      void updatePushPresence(null);
    };
  }, [updatePushPresence]);
}
